import React, { useEffect, useState } from "react";
import styled from "styled-components";

const ImageSlider = ({ images }) => {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    
    window.addEventListener("resize", checkMobile);
    
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {

    const imagesPerSlide = isMobile ? 1 : 2;
    const total = Math.ceil(images.length / imagesPerSlide);
    
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % total);
    }, 4000);
    
    return () => clearInterval(interval);
  }, [images.length, isMobile]);

  const getVisibleImages = () => {
    const imagesPerSlide = isMobile ? 1 : 2;
    const visible = [];
    
    for (let i = 0; i < images.length; i += imagesPerSlide) {
      visible.push(images.slice(i, i + imagesPerSlide));
    }
    
    return visible;
  };

  const slides = getVisibleImages();
  const translateValue = -(index * 100);

  return (
    <SliderContainer>
      <SlideTrack translateValue={translateValue}>
        {slides.map((group, idx) => (
          <SlideGroup key={idx} isMobile={isMobile}>
            {group.map((imageObj, i) => (
              <Slide key={i} isMobile={isMobile}>
                <ImageContainer>
                  <Image src={imageObj.image} alt={imageObj.description || `slide-${idx}-${i}`} />
                  {imageObj.description && (
                    <Description>
                      <DescriptionText>{imageObj.description}</DescriptionText>
                    </Description>
                  )}
                </ImageContainer>
              </Slide>
            ))}
          </SlideGroup>
        ))}
      </SlideTrack>
    </SliderContainer>
  );
};

const SliderContainer = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin: 2rem auto;

  @media only screen and (min-width: 768px){
    margin: 4rem auto;
  }
`;

const SlideTrack = styled.div`
  display: flex;
  transition: transform 1s ease-in-out;
  transform: translateX(${(props) => props.translateValue}%);
  width: 100%;
`;

const SlideGroup = styled.div`
  display: flex;
  flex: 0 0 100%;
  width: 100%;
`;

const Slide = styled.div`
  flex: 0 0 ${props => props.isMobile ? '100%' : '50%'};
  padding: 0 10px;
  box-sizing: border-box;
`;

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 20px;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const Description = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  padding: 10px 15px;
  box-sizing: border-box;
  z-index: 10;
`;

const DescriptionText = styled.p`
  color: #ffffff !important;
  margin: 0;
  font-size: 0.9rem;
  text-align: center;
  font-weight: 500;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

export default ImageSlider;